import useProfiler from "hooks/useProfiler";
import { createTrackingUtils } from "..";

const utils = createTrackingUtils({
  name: "flights_web_dsa_banner_fix",
  stages: {
    search_results: 1,
    banner_rendered_on_search_results: 2,
    banner_dismissed: 3,
    direct: 4,
    meta: 5,
    desktop: 6,
    mobile: 7
  },
  defaultStage: 1,
  goals: {
    dismiss_banner: 1
  }
});

const { stages, goals } = utils;

export const useTrackDsaBannerFix = () => {
  const { isDirect, isMeta, isDesktop, isMobile } = useProfiler();

  stages.search_results();

  return {
    trackDismiss: () => {
      goals.dismiss_banner();
      stages.banner_dismissed();
    },
    trackStages: () => {
      stages.banner_rendered_on_search_results();
      isDirect() && stages.direct();
      isMeta() && stages.meta();
      isDesktop() && stages.desktop();
      isMobile() && stages.mobile();
    }
  };
};

export default utils;
